"use strict";

exports.__esModule = true;
exports.ChangeOperatorActionElement = void 0;
var _react = _interopRequireWildcard(require("react"));
var _DeviceContext = require("../../Device/DeviceContext");
var _TimelineSubscription = require("../../Timeline/TimelineSubscription");
var _Timeline = require("../../Timeline");
var _ChangeOperatorDialog = require("./ChangeOperatorDialog");
var _Translator = require("../../Core/Translator");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
/**
 * Provides a button to be rendered on a configurable view
 */
var ChangeOperatorActionElement = exports.ChangeOperatorActionElement = function ChangeOperatorActionElement(props) {
  // state
  var _useState = (0, _react.useState)(false),
    isDialogOpen = _useState[0],
    setIsDialogOpen = _useState[1];
  // context
  var device = _react["default"].useContext(_DeviceContext.DeviceContext);
  var _React$useContext = _react["default"].useContext(_Translator.TranslatorContext),
    translate = _React$useContext.translate;
  var toggleDialog = function toggleDialog() {
    setIsDialogOpen(!isDialogOpen);
  };
  var invoke = function invoke() {
    setIsDialogOpen(true);
  };
  var childProps = {
    invoke: invoke
  };
  if (!isDialogOpen) {
    return props.children(childProps);
  }
  var label = props.label || translate(("UserAction.ChangeOperator.label", "Change Operator"));
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, props.children(childProps), /*#__PURE__*/_react["default"].createElement(_TimelineSubscription.TimelineSubscription, {
    defaultValue: null,
    timelineName: _Timeline.TIME_SERIES_OPERATOR,
    query: {
      device: device ? device.uuid : undefined
    },
    isCurrent: true
  }, function (packet) {
    return /*#__PURE__*/_react["default"].createElement(_ChangeOperatorDialog.ChangeOperatorDialog, {
      label: label,
      operator: packet && packet.value && packet.value.operator || "",
      isOpen: isDialogOpen,
      toggleDialog: toggleDialog,
      changeOperatorType: props.changeOperatorType
    });
  }));
};